import { Facebook, Instagram, Linkedin, Mail, MessageCircle, Youtube } from "lucide-react";
import { siteContent } from "@/data/siteContent";

const iconMap = {
  mail: Mail,
  whatsapp: MessageCircle,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  facebook: Facebook,
};

export const ContactSection = () => {
  const { contact } = siteContent;

  return (
    <section id="contact" className="section-shell section-shell--paper contact-section" aria-labelledby="contact-title" data-testid="contact-section">
      <div className="site-container contact-layout">
        <div>
          <h2 id="contact-title" className="section-title" data-testid="contact-title">{contact.heading}</h2>
          <p className="section-intro" data-testid="contact-intro">{contact.intro}</p>
        </div>
        <div className="contact-links" data-testid="contact-links">
          {contact.links.map((link, index) => {
            const Icon = iconMap[link.icon];
            return (
              <a href={link.destination} target={link.destination.startsWith("http") ? "_blank" : undefined} rel={link.destination.startsWith("http") ? "noreferrer" : undefined} key={link.label} data-testid={`contact-link-${index + 1}`}>
                <Icon size={19} aria-hidden="true" />
                <span><small>{link.label}</small>{link.display}</span>
              </a>
            );
          })}
          <p className="contact-note" data-testid="contact-community-note">{contact.communityNote}</p>
        </div>
      </div>
    </section>
  );
};